var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-loading" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "30px",
          height: "30px",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 100 100",
          preserveAspectRatio: "xMidYMid"
        }
      },
      [
        _c("rect", {
          attrs: { x: "0", y: "0", width: "100", height: "100", fill: "none" }
        }),
        _c("circle", {
          attrs: {
            cx: "50",
            cy: "50",
            r: "40",
            stroke: "none",
            fill: "none",
            "stroke-width": "10",
            "stroke-linecap": "round"
          }
        }),
        _c("circle", {
          staticClass: "icon-loading__circle",
          attrs: {
            cx: "50",
            cy: "50",
            r: "40",
            stroke: "#535CF9",
            fill: "none",
            "stroke-width": "6",
            "stroke-linecap": "round"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eacf96c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eacf96c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-loading-view.vue
// module id = 419
// module chunks = 76